import { useMemo } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { BankAccountsResponse, BankAccountsFilters } from '../models/BankAccount';
import { BankAccountsApiAdapter } from '../adapters/BankAccountsApiAdapter';

const DEFAULT_FILTERS: BankAccountsFilters = {};

export const BANK_ACCOUNTS_QUERY_KEY = 'bankAccounts';

export const useBankAccounts = (filters?: BankAccountsFilters) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const apiAdapter = useMemo(
    () => new BankAccountsApiAdapter(httpClient),
    [httpClient]
  );
  const resolvedFilters = filters ?? DEFAULT_FILTERS;

  return useQuery<BankAccountsResponse, Error>({
    queryKey: [BANK_ACCOUNTS_QUERY_KEY, resolvedFilters],
    queryFn: () => apiAdapter.getBankAccounts(resolvedFilters),
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
  });
};

